<template>
  <div :class="skeletonBlockClass" :style="skeletonBlockStyle">
    <div :class="skeletonContentClass" :style="skeletonContentStyle" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  size: 'tiny' | 'small' | 'medium' | 'large'
  width?: string
  contentHeight?: string
  height?: string
}>()

const skeletonContentClass = computed(() => {
  return ['skeleton-block__content', `skeleton-block__content--${props.size}`]
})

const skeletonContentStyle = computed(() => {
  return { height: props.contentHeight }
})

const skeletonBlockClass = computed(() => [
  'skeleton-block',
  `skeleton-block--${props.size}`,
])

const skeletonBlockStyle = computed(() => {
  const { height, width } = props
  return { height, width }
})
</script>

<style scoped lang="scss">
.skeleton-block {
  display: flex;
  align-items: center;
  height: 100%;

  &--tiny {
    width: 100px;
    height: $spacing-4xs;
  }

  &--small {
    width: 150px;
    height: $spacing-3xs;
  }

  &--medium {
    width: 200px;
    height: $spacing-s;
  }

  &--large {
    width: 300px;
    height: $spacing-l;
  }
  &__content {
    border-radius: $spacing-4xs;
    height: 100%;
    width: 100%;
    @include skeletonLoadingAnimation;

    &--tiny {
      height: $spacing-4xs;
    }

    &--small {
      height: $spacing-3xs;
    }

    &--medium {
      height: $spacing-s;
    }

    &--large {
      height: $spacing-l;
    }
  }
}
</style>
